import React from 'react';

const ZenPostHeroScreenshot = ({
  src,
  alt,
  sectionClassName = 'px-4 pb-20 sm:pb-20 mt-8',
  containerClassName = 'max-w-5xl mx-auto',
  frameClassName = 'rounded-2xl border border-brand/30 overflow-hidden shadow-2xl shadow-black/50',
  imgClassName = 'w-full h-auto',
  imgAspectClassName = 'w-full h-full object-cover',
  aspectClassName = '',
  caption,
  captionClassName = 'mt-4 text-sm text-[#e6dbca]/80 text-center',
  linkHref,
  linkTarget = '_blank',
  linkRel = 'noopener noreferrer'
}) => {
  if (!src) {
    return null;
  }

  const hasAspect = Boolean(aspectClassName);

  const image = (
    <img
      src={src}
      alt={alt || ''}
      className={hasAspect ? imgAspectClassName : imgClassName}
    />
  );

  return (
    <section className={sectionClassName}>
      <div className={containerClassName}>
        <figure>
          <div
            className={[
              frameClassName,
              hasAspect ? 'relative' : '',
              aspectClassName
            ]
              .filter(Boolean)
              .join(' ')}
          >
            {linkHref ? (
              <a href={linkHref} target={linkTarget} rel={linkRel}>
                {image}
              </a>
            ) : (
              image
            )}
          </div>
          {caption ? <p className={captionClassName}>{caption}</p> : null}
        </figure>
      </div>
    </section>
  );
};

export default ZenPostHeroScreenshot;
